import * as React from 'react';

export default class CarouselWIP extends React.Component<CarouselWIPProps> {}

export type CarouselWIPImage = Partial<HTMLImageElement> & { src: string };

export interface CarouselWIPProps {
  dataHook?: string;
  className?: string;
  children?: React.ReactNode;
  images?: CarouselWIPImage[];
  controlsSkin?: 'standard' | 'inverted' | 'light';
  showControlsShadow?: boolean;
  infinite?: boolean;
  initialSlideIndex?: number;
  afterChange?: (currentSlide: number) => void;
  beforeChange?: (currentSlide: number, nextSlide: number) => void;
  controlsPosition?: 'sides' | 'overlay' | 'bottom' | 'none';
  controlsSize?: 'tiny' | 'small' | 'medium';
  controlsStartEnd?: 'disabled' | 'hidden';
  slidingType?: 'align-to-start' | 'reveal-one' | 'reveal-chunk';
  startEndOffset?: number;
  gutter?: number;
  sidesGradientColor?: string;
  imagesPosition?: string;
  imagesFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  autoplay?: boolean;
  hideDots?: boolean;
  variableWidth?: boolean;
}
